import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NotificationsService } from 'angular2-notifications';
import { SystemComponentViewModel, SystemsInInventoryViewModel } from '../inventory-models';
import { InventoryService } from '../inventory-service.service';
import { Observable } from 'rxjs';
import { ActionService } from '../../action/action.service.service';
import { Make } from '../../../../app/entities/global/model';
import { AvailableActionsForComponentInInventory, AvailableActionViewModel, ComponentOnSystemViewModel, GeneralActionViewModel, ReplacementCompartmentViewModel } from '../../action/action-models';
import { LoadingService } from '../../../../app/shared/services/loading.service';

@Component({
  selector: 'app-inventory-record-action',
  templateUrl: './inventory-record-action.component.html',
  styleUrls: ['./inventory-record-action.component.scss'],
})
export class InventoryRecordActionComponent implements OnInit {
  system: SystemsInInventoryViewModel;

  componentList: SystemComponentViewModel[] = [];
  isLoading = true;
  TotalInitalCost: number = 0;
  TotalRepairCost: number = 0;
  FrameCost: number = 0;
  FrameRepairCost: number = 0;
  NewSMU: number
  ActionDate: Date;
  Buttondisabled: boolean = false;
  constructor(public dialogRef: MatDialogRef<InventoryRecordActionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _notification: NotificationsService, private inventoryService: InventoryService, private _actionService: ActionService, private loadingService: LoadingService,) { }

  ngOnInit(): void {
    this.system = this.data.system;
    this.system.ActionSelectionId = 0;
    this.system.SysReplaceActionId = 0;
    console.log("system", this.system);
    this.loadHistoriesAndInfo();
    this.LoadMakes();
  }
  onNoClickPopup(): void {
    this.dialogRef.close();
  }

  loadHistoriesAndInfo() {
    this.isLoading = true;
    const info = this.inventoryService.getSystemComponentsInfo(
      this.system.SystemId
    );
    Observable.forkJoin([info, history]).subscribe(results => {
      this.isLoading = false;
      this.componentList = results[0];
      this.TotalInitalCost = 0;
      this.TotalRepairCost = 0;
      this.FrameCost = this.componentList[0].FrameCost
      this.FrameRepairCost = this.componentList[0].FrameRepairCost
      this.componentList.forEach(x => {
        this.TotalInitalCost = this.TotalInitalCost + x.InititalCost,
          this.TotalRepairCost = this.TotalRepairCost + x.TotalCost
      })
this.isLoading = false;
    });
  }
  Makes: Make[];
  LoadMakes() {
    this._actionService.GetComponentReplacementBrends().subscribe(result => {
      this.Makes = result;
      //this._loading.finishedLoading();
    },
      error => { console.error(error); });
  }
  ChangeActionSelection() {

  }
  actionHelper: AvailableActionsForComponentInInventory = new AvailableActionsForComponentInInventory();
  availableActions: AvailableActionViewModel[] = [];
  isloadingReplacementCompart: boolean;
  isReplaceWithNewAction: boolean;
  showCost: boolean = false;
  availableCompartments: ReplacementCompartmentViewModel[] = [];
  allRollers: ComponentOnSystemViewModel[];
  allComponents: ComponentOnSystemViewModel[];

  GetAvailableActions(component: SystemComponentViewModel) {

    const actions = this.actionHelper.GetActions(component.CompartType);

    component.AvailableActions = this.actionHelper
      .GetActions(component.CompartType)
      .filter(action => action.ActionTypeName?.toLowerCase().startsWith('replace'));
  }

  // actionChanged(event, component: SystemComponentViewModel) {
  //   const action = component.AvailableActions.find(
  //     a => a.ActionTypeId === event.value
  //   );
  //   const checkString = action.ActionTypeName.split(' ');
  //   if (checkString[0] === 'Replace') {
  //     this.loadingService.startLoading();
  //     this.isloadingReplacementCompart = true;
  //     this.isReplaceWithNewAction = true;
  //     this.showCost = true;
  //     this._actionService
  //       .getReplacementComponentOptions(component.EqunitId)
  //       .subscribe(r => {
  //         this.loadingService.finishedLoading();
  //         this.isloadingReplacementCompart = false;
  //         console.log(r);
  //         component.availableCompartments = r;
  //       });
  //   } else {
  //     this.isReplaceWithNewAction = false;
  //     this.showCost = false;
  //   }

  //   if ( +action.ActionTypeId === 10602 || +action.ActionTypeId === 17 || +action.ActionTypeId === 10702 ) {
  //     this.allRollers = this.allComponents.filter(c => c.CompartTypeId === component.CompartType);
  //     this.showCost = false;
  //   }

  // }
  actionChanged(
    event: any,
    component: SystemComponentViewModel
  ): void {

    const action = component.AvailableActions?.find(
      a => +a.ActionTypeId === +event.value
    );

    if (!action) {
      return;
    }

    const actionName =
      action.ActionTypeName?.toLowerCase() || '';

    if (actionName.startsWith('replace')) {

      this.loadingService.startLoading();

      this.isloadingReplacementCompart = true;
      this.isReplaceWithNewAction = true;
      this.showCost = true;

      this._actionService
        .getReplacementComponentOptions(component.EqunitId)
        .subscribe({
          next: (r) => {

            component.availableCompartments = r || [];

            this.loadingService.finishedLoading();
            this.isloadingReplacementCompart = false;

            console.log(
              'Replacement options:',
              component.availableCompartments
            );
          },

          error: (error) => {

            console.error(
              'Error getting replacement options:',
              error
            );

            component.availableCompartments = [];

            this.loadingService.finishedLoading();
            this.isloadingReplacementCompart = false;
          }
        });

    } else {

      this.isReplaceWithNewAction = false;
      this.showCost = false;
    }
  }

  OnSelectedReplacementCompart(event, component: SystemComponentViewModel) {
    // get budget life
    this.inventoryService.getSystemComponentsInfo(this.system.SystemId).subscribe((info: SystemComponentViewModel[]) => {
      const matchingInfoComponent = info.find((infoComponent: SystemComponentViewModel) =>
        ((infoComponent.CompartType === component.CompartType) && (infoComponent.Pos === component.Pos)))

      if (matchingInfoComponent) {
        component.ActionWorn = 0;
        component.ActionBudgetLife = matchingInfoComponent.Budget;
        component.ActionBrandId = matchingInfoComponent.MakeId;
        //component.ActionBudgetDistance = matchingInfoComponent.DistanceBudget;
        component.ActionCMU = 0;
        //component.ActionDOC = matchingInfoComponent.DOC;
        component.ActionCost = 0;

        component.ActionSelectionId = 2;
        // Add other properties as needed
      }
    });
  }

  onTopActionChanged(): void {

    if (this.system.ActionSelectionId !== 2) {

      // Reset all component selections
      this.componentList.forEach(component => {
        component.ActionSelectionId = null;
        component.SelectedActionTypeId = null;
        component.ReplaceComponentCompartId = null;

        component.AvailableActions = [];
        component.availableCompartments = [];

        component.ActionBrandId = null;
        component.ActionWorn = null;
        component.ActionBudgetLife = null;
        component.ActionCMU = null;
        component.ActionCost = null;
      });

      this.system.SysReplaceActionId = null;

      return;
    }
  }
  onTopActionTypeChanged(): void {

    if (
      this.system.ActionSelectionId === 2 &&
      this.system.SysReplaceActionId === 3
    ) {
      this.applyNewComponentsToAll();
    }
  }
  applyNewComponentsToAll(): void {

    if (!this.componentList || this.componentList.length === 0) {
      return;
    }

    this.loadingService.startLoading();

    const requests = this.componentList.map(component => {

      // Make sure action is Replace
      component.ActionSelectionId = 2;

      // Get actions for this component type
      component.AvailableActions = this.actionHelper
        .GetActions(component.CompartType)
        .filter(action =>
          action.ActionTypeName?.toLowerCase().startsWith('replace')
        );

      // Find "Replace With New <Component>"
      const newComponentAction = component.AvailableActions.find(action =>
        action.ActionTypeName?.toLowerCase().startsWith('replace with new')
      );

      if (!newComponentAction) {
        console.warn(
          'No New Component action found for:',
          component.Name,
          component.CompartType
        );

        return this._actionService
          .getReplacementComponentOptions(component.EqunitId)
          .toPromise()
          .then(replacements => {

            component.availableCompartments = replacements || [];

            this.setDefaultComponentValues(component);

          });
      }

      // Select action type
      component.SelectedActionTypeId = newComponentAction.ActionTypeId;

      // Get available replacement components
      return this._actionService
        .getReplacementComponentOptions(component.EqunitId)
        .toPromise()
        .then(replacements => {

          component.availableCompartments = replacements || [];

          // Automatically select first replacement
          if (component.availableCompartments.length > 0) {

            const firstReplacement =
              component.availableCompartments[0];
            component.ReplaceComponentCompartId = firstReplacement.Id;
          }
          this.setDefaultComponentValues(component);
        })
        .catch(error => {
          console.error('Error loading replacement components for:',component.Name,error);
          component.availableCompartments = [];
          this.setDefaultComponentValues(component);
        });
    });
    Promise.all(requests).then(() => {
        this.loadingService.finishedLoading();
      })
      .catch(error => {
        console.error(
          'Error applying New Components:',
          error
        );
        this.loadingService.finishedLoading();
      });
  }
  private setDefaultComponentValues(component: SystemComponentViewModel): void {
    component.ActionSelectionId = 2;
    component.ActionWorn = 0;
    component.ActionBrandId = component.MakeId;
    component.ActionBudgetLife =
    component.Budget ?? null;
    component.ActionCMU = 0;
    component.ActionCost = 0;
  }

  RecordActions(): void {
    if (!this.componentList || this.componentList.length === 0) {
      this._notification.warn('No components available to record.');
      return;
    }
   
    if (!this.ActionDate) {
      this._notification.warn('Please select Date of Action.');
      return;
    }
  
    if (this.NewSMU === null || this.NewSMU === undefined || Number(this.NewSMU) <= 0) {
      this._notification.warn('Please enter valid Frame Hours / SMU.');
      return;
    }
   
    const selectedComponents = this.componentList.filter(component => component.ActionSelectionId && component.ActionSelectionId > 0);
    if (selectedComponents.length === 0) {
      this._notification.warn('Please select an action for at least one component.');
      return;
    }
   
    for (const component of selectedComponents) {
     
      if (component.ActionSelectionId === 1) {
        continue;
      }
      
      if (component.ActionSelectionId === 2) {

        if (!component.SelectedActionTypeId || component.SelectedActionTypeId <= 0) {
          this._notification.warn(`Please select Action Type for ${component.Name}.`);
          return;
        }
        if (!component.ActionBrandId || component.ActionBrandId <= 0) {
          this._notification.warn(`Please select a component Make for ${component.Name}.`);
          return;
        }

        if (!component.ReplaceComponentCompartId ||
          component.ReplaceComponentCompartId <= 0) {
          this._notification.warn(`Please select Available Replacement for ${component.Name}.`);
          return;
        }
      }
    }
    this.Buttondisabled = true;
    const requests = selectedComponents.filter(component => component.ActionSelectionId === 2)
      .map(component => {

        const action: any = {
          ActionEqUnitId: component.EqunitId,
          ActionTypeId: component.SelectedActionTypeId,
          ReplaceComponentCompartId: component.ReplaceComponentCompartId,
          MakeId: component.ActionBrandId,
          //Worn: component.ActionWorn ?? 0,
          BudgetLife: component.ActionBudgetLife ?? 0,
          NewSMU: this.NewSMU ?? 0,
          CMU: component.ActionCMU ?? 0,
          Cost: component.ActionCost ?? 0,
          ActionDate: this.ActionDate,
        };
        return this._actionService.recordNewInventoryAction(action);
      });

    if (requests.length === 0) {
      this.Buttondisabled = false;
      this._notification.warn('No action available to save.');
      return;
    }
    Observable.forkJoin(requests).subscribe(
      results => {
        console.log('Inventory action results:', results);
        const failed = results.filter((result: any) => !result || !result.m_Item1);
        if (failed.length === 0) {
          this._notification.success(`${requests.length} inventory action(s) recorded successfully.`  );
          this.dialogRef.close(true);
        } else {
          this._notification.error(`${failed.length} inventory action(s) failed to record.`);
        }
        this.Buttondisabled = false;
      },
      error => {
        console.error('Error recording inventory actions:', error);
        this._notification.error('Failed to record inventory actions.');
        this.Buttondisabled = false;
      }
    );
  }


}
